import React from 'react'
import { Box, useMediaQuery } from '@material-ui/core'
import { Code, Work, School } from '@material-ui/icons'
import { resumeData } from '../../util/resumeData'
import HeroSection from './HeroSection'
import ResumeSection from './ResumeSection'
import ExperienceTimeline from './ExperienceTimeline'
import SkillsSection from './SkillsSection'
import PresentationsGallery from './PresentationsGallery'
import EducationSection from './EducationSection'
import DownloadResumeButton from './DownloadResumeButton'

const CyberpunkResumeScrolling = () => {
  const isMobile = useMediaQuery('(max-width: 768px)')
  const downloadPDF = () => {
    window.print()
  }

  return (
    <Box style={{
      background: '#0a0a0a',
      minHeight: '100vh',
      position: 'relative',
      width: '100%',
      maxWidth: '100vw',
      overflowX: 'hidden'
    }}>

      <HeroSection
        personalInfo={resumeData.personalInfo}
        technicalLeadership={resumeData.technicalLeadership}
      />

      <ResumeSection
        title="TECHNICAL EXPERTISE"
        icon={Code}
        background="rgba(10, 10, 20, 0.98)"
      >
        <SkillsSection
          programmingLanguages={resumeData.technicalExpertise?.programmingLanguages || []}
          cloudProviders={resumeData.technicalExpertise?.providers || []}
          subjectMatterExpertise={resumeData.technicalExpertise?.subjectMatterExpertise || []}
          technologiesAndFrameworks={resumeData.technologiesAndFrameworks || {}}
        />
      </ResumeSection>

      <ResumeSection
        title="PROFESSIONAL EXPERIENCE"
        icon={Work}
        background="rgba(10, 10, 20, 0.98)"
        minHeight="auto"
      >
        <ExperienceTimeline experiences={resumeData.professionalExperience}/>
      </ResumeSection>

      <ResumeSection
        title="Knowledge Vault"
        icon={null}
        background="rgba(10, 10, 20, 0.98)"
      >
        <PresentationsGallery presentations={resumeData.presentations}/>
      </ResumeSection>

      <ResumeSection
        title="EDUCATION & LANGUAGES"
        icon={School}
        background="rgba(10, 10, 20, 0.98)"
      >
        <EducationSection
          education={resumeData.education}
          languages={resumeData.languages}
        />
      </ResumeSection>
    </Box>
  )
}

export default CyberpunkResumeScrolling
export { DownloadResumeButton }
